import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/ladder',
  redirect: 'noredirect',
  name: 'ladder',
  component: Layout,
  children: [
    {
      path: 'ladder',
      component: () => import('@/views/ladder/index.vue'),
      name: 'ladder',
      meta: {
        title: '阶段汇报',
        icon: 'resource',
        requireAuth: true
      }
    },
  ]

}

export default equipRouter
